import $ from "jquery";
import jsfix from "jsfix";

jsfix.register("js-scroll-to", function ($el, to) {
  $el.click(function () {
    $("body,html").animate(
      {
        scrollTop: $(to).offset().top,
      },
      1000
    );
  });
});

class Slider {
  constructor(el) {
    this.el = el;
    this.count = el.find("li").length;
    this.width = window.innerWidth;
    this.current = 0;
    this.parent = el.find("ul")[0];
  }

  setSlide(slide) {
    if (slide < 0) slide = this.count - 1;
    if (slide >= this.count) {
      slide = 0;
    }
    this.current = slide;
    this.parent.scrollTo({
      left: slide * this.width,
      behavior: "smooth",
    });
  }
}

jsfix.register("js-slider", function ($el, config) {
  const wait_t = 3000;

  const slide = new Slider($el);
  config = config || "interval";

  $el.data("slide", slide);

  if (config === "interval") {
    setInterval(() => {
      // console.log({ slide });
      let slide_new = slide.current + 1;
      if (slide_new >= slide.count) {
        slide_new = 0;
      }

      slide.setSlide(slide_new);
    }, wait_t);
  }

  window.addEventListener("resize", () => {
    slide.width = window.innerWidth;
    slide.setSlide(0);
  });
});

// Slide is defined as "element_selector,slide_number"
jsfix.register("js-goto-slide", function ($el, slide) {
  $el.click(function () {
    const slide_split = slide.split(",");
    const target_slide_number = slide_split[1];
    const target_slide_obj = $(slide_split[0]);

    const slide_obj = $(target_slide_obj).data("slide");
    if (!slide_obj) {
      console.error("Slider not found");
      return;
    }

    if (target_slide_number === "prev") {
      target_slide_number = slide_obj.current - 1;
    } else if (target_slide_number === "next") {
      target_slide_number = slide_obj.current + 1;
    } else {
      target_slide_number = parseInt(target_slide_number);
    }
    slide_obj.setSlide(target_slide_number);
  });
});
